import React, { useEffect, useState } from "react";
import { DashboardShell } from "@/components/DashboardLayout";
import { BackButton } from "@/components/Layout";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { api, fmtSASTDateTime } from "@/lib/api";

export default function AdminAudit() {
  const [logs, setLogs] = useState([]);
  useEffect(() => { api.get("/admin/audit").then(({ data }) => setLogs(data.logs || [])); }, []);
  return (
    <DashboardShell role="admin">
      <BackButton to="/admin" />
      <p className="text-xs tracking-[0.22em] uppercase font-bold text-[#00C4B4]">Immutable ledger</p>
      <h1 className="font-display mt-2 text-3xl font-bold text-[#0A2540]">Audit log ({logs.length})</h1>
      <div className="mt-6 bg-white border border-[#E5E7EB] rounded-2xl overflow-x-auto">
        <Table data-testid="audit-table">
          <TableHeader>
            <TableRow>
              <TableHead>Timestamp</TableHead>
              <TableHead>Action</TableHead>
              <TableHead>Resource</TableHead>
              <TableHead>Actor</TableHead>
              <TableHead>IP</TableHead>
              <TableHead>Metadata</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {logs.length === 0 && <TableRow><TableCell colSpan={6} className="text-center py-8 text-[#666666]">No audit entries</TableCell></TableRow>}
            {logs.map((l) => (
              <TableRow key={l.id}>
                <TableCell className="text-xs whitespace-nowrap">{fmtSASTDateTime(l.created_at)}</TableCell>
                <TableCell><code className="text-xs bg-[#F8F9FA] px-2 py-0.5 rounded font-mono text-[#0A2540]">{l.action}</code></TableCell>
                <TableCell className="text-xs">{l.resource_type} · {l.resource_id?.substring(0, 12) || "—"}</TableCell>
                <TableCell className="text-xs font-mono">{l.actor_id?.substring(0, 12) || "—"}</TableCell>
                <TableCell className="text-xs">{l.ip || "—"}</TableCell>
                <TableCell className="text-[10px] max-w-xs"><pre className="overflow-x-auto">{JSON.stringify(l.metadata || {}, null, 0)}</pre></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </DashboardShell>
  );
}
